const GrassComponents = [
    {
        asset_name: "grass01",
        pos_x: 672,
        pos_y: 608,
        depth: 2
    },
    {
        asset_name: "grass02",
        pos_x: 0,
        pos_y: 763,
        depth: 4
    },
    {
        asset_name: "grass03",
        pos_x: 316,
        pos_y: 1021,
        depth: 6
    },
    {
        asset_name: "grass04",
        pos_x: 614,
        pos_y: 1236,
        depth: 8
    },
    {
        asset_name: "grass05",
        pos_x: 0,
        pos_y: 1372,
        depth: 10
    }
]

const BunnyComponent = [
    {
        asset_name: ["bunny01", "bunny02"],
        pos_x: 672,
        pos_y: 345,
        depth: 1,
        PeekPos: {
            y: 345,
            min_x: 672,
            max_x: 911
        },
        points: 1,
        maskHeight: 400
    },
    {
        asset_name: ["bunny01", "bunny02"],
        pos_x: 0,
        pos_y: 491,
        depth: 3,
        PeekPos: {
            y: 491,
            min_x: 0,
            max_x: 250
        },
        points: 1,
        maskHeight: 400
    },
    {
        asset_name: ["bunny01", "bunny02"],
        pos_x: 316,
        pos_y: 748,
        depth: 5,
        PeekPos: {
            y: 748,
            min_x: 316,
            max_x: 596
        },
        points: 1,
        maskHeight: 400
    },
    {
        asset_name: ["bunny01", "bunny02"],
        pos_x: 614,
        pos_y: 951,
        depth: 7,
        PeekPos: {
            y: 951,
            min_x: 614,
            max_x: 911
        },
        points: 1,
        maskHeight: 400
    },
    {
        asset_name: ["bunny01", "bunny02"],
        pos_x: 0,
        pos_y: 1125,
        depth: 9,
        PeekPos: {
            y: 1125,
            min_x: 0,
            max_x: 280
        },
        points: 1,
        maskHeight: 400
    },
];

const GoldBunnyComponent = [
    {
        asset_name: ["goldbunny"],
        pos_x: 672,
        pos_y: 373,
        depth: 1,
        PeekPos: {
            y: 373,
            min_x: 672,
            max_x: 817
        },
        points: 3,
        maskHeight: 400
    },
    {
        asset_name: ["goldbunny"],
        pos_x: -27,
        pos_y: 496,
        depth: 3,
        PeekPos: {
            y: 496,
            min_x: -27,
            max_x: 156
        },
        points: 3,
        maskHeight: 400
    },
    {
        asset_name: ["goldbunny"],
        pos_x: 316,
        pos_y: 743,
        depth: 5,
        PeekPos: {
            y: 743,
            min_x: 316,
            max_x: 502
        },
        points: 3,
        maskHeight: 400
    },
    {
        asset_name: ["goldbunny"],
        pos_x: 614,
        pos_y: 974,
        depth: 7,
        PeekPos: {
            y: 974,
            min_x: 614,
            max_x: 817
        },
        points: 3,
        maskHeight: 400
    },
    {
        asset_name: ["goldbunny"],
        pos_x: -47,
        pos_y: 1140,
        depth: 9,
        PeekPos: {
            y: 1140,
            min_x: -47,
            max_x: 219
        },
        points: 3,
        maskHeight: 400
    },
];

const OtterComponent = [
    {
        asset_name: ["otter"],
        pos_x: 672,
        pos_y: 455,
        depth: 1,
        PeekPos: {
            y: 455,
            min_x: 672,
            max_x: 834
        },
        points: -2,
        maskHeight: 330
    },
    {
        asset_name: ["otter"],
        pos_x: 0,
        pos_y: 568,
        depth: 3,
        PeekPos: {
            y: 568,
            min_x: 0,
            max_x: 173
        },
        points: -2,
        maskHeight: 330
    },
    {
        asset_name: ["otter"],
        pos_x: 316,
        pos_y: 845,
        depth: 5,
        PeekPos: {
            y: 845,
            min_x: 316,
            max_x: 519
        },
        points: -2,
        maskHeight: 330
    },
    {
        asset_name: ["otter"],
        pos_x: 614,
        pos_y: 1041,
        depth: 7,
        PeekPos: {
            y: 1041,
            min_x: 614,
            max_x: 829
        },
        points: -2,
        maskHeight: 330
    },
    {
        asset_name: ["otter"],
        pos_x: 0,
        pos_y: 1204,
        depth: 9,
        PeekPos: {
            y: 1204,
            min_x: 0,
            max_x: 218
        },
        points: -2,
        maskHeight: 330
    },
];

export { GrassComponents, BunnyComponent, GoldBunnyComponent, OtterComponent };